export default {
  title: 'Missed orders',
  card_title: 'Missed order emails',
  intro:
    "If nobody accepts an order within {{minutes}} minutes, it's rejected automatically. Everyone on this list then gets an email with the order, so someone can follow up.",
  default: {
    owner: 'Restaurant owner',
    partner: 'Partner',
    owner_missing: "The restaurant owner ({{email}}) won't get these emails.",
    partner_missing: "The partner's default address ({{email}}) won't get these emails.",
  },
  empty: 'Nobody would hear about missed orders. Add at least one email to save.',
  save_error: "Couldn't save the emails. Check your connection and try again.",
  load_error: "Couldn't load the emails. Check your connection and try again.",
  unavailable: "Missed order emails aren't available for this restaurant.",
  buttons: {
    save: 'Save',
    retry: 'Try again',
  },
  toasts: {
    saved: 'Missed order emails saved',
  },
};
